import React from "react";
import { RootRouteProps } from "router/types/stack";

import { useRoute } from "@react-navigation/native";

import { View, Platform } from "react-native";
import {
  Icon,
  Text,
  Error,
  Header,
  Loading,
  ExportPDF,
  ListContainer,
} from "component";

import { mq, priceFormatter, makeFactorPdfTemplate } from "utils";
import { sizes, colors, strings } from "asset/constant";
import { useInitialLoading } from "hook";
import { useFactor } from "client/api";
import { css } from "style";

export default function OrderDetails() {
  const params = useRoute<RootRouteProps<"order_details">>().params;

  const { initialLoading } = useInitialLoading();
  const { data, isLoading, isError, error, refetch, isRefetching } = useFactor(
    params.id
  );

  const _renderContent = () => {
    if (isLoading || initialLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error error={error} reset={refetch} loading={isRefetching} />;
    }

    return (
      <>
        <View
          style={{
            ...css.rRowCenterAlign,
            ...css.justifySBetween,
            width: "95%",
            ...css.selfCenter,
            padding: 5,
          }}
        >
          <View>
            <Text size={"xl"} weight="extraBold">
              {data?.data?.company_name}
            </Text>
            <View
              style={{
                ...css.rRowCenterAlign,
                ...Platform.select({ web: { marginTop: 5 } }),
              }}
            >
              <Icon name="calendar" size={mq(14)} />
              <Text size={"lg"} weight="bold">
                {" "}
                {data?.data?.created_at}{" "}
              </Text>
            </View>
          </View>
          <View style={{ ...css.centralElements }}>
            <Text weight="extraBold">جمع خرید</Text>
            <View
              style={{
                ...css.rRowCenterAlign,
                ...Platform.select({ web: { marginTop: 5 } }),
              }}
            >
              <Text size={"lg"} color={colors.dark_theme} weight="black">
                {priceFormatter(data?.data?.total)}
              </Text>
              <Text weight="extraBold" size={"xxs"} color={colors.text.gray}>
                {" "}
                {strings.currency}
              </Text>
            </View>
          </View>
        </View>

        <View
          style={{
            paddingHorizontal: sizes.space,
            backgroundColor: data?.data?.status?.color + "19",
            ...css.centralElements,
            paddingVertical: mq(10),
          }}
        >
          <View
            style={{
              ...css.rRowCenterAlign,
              paddingHorizontal: sizes.space,
              ...css.centralElements,
              paddingVertical: mq(10),
            }}
          >
            <Text weight="bold">سفارش شما در وضعیت </Text>
            <Text color={data?.data?.status?.color} weight="extraBold">
              «{data?.data?.status?.title}»
            </Text>
            <Text weight="bold"> می باشد</Text>
          </View>

          {data?.data?.admin_description && (
            <Text align="center">«{data?.data?.admin_description}»</Text>
          )}
        </View>

        <ListContainer>
          {data?.data?.description && (
            <View>
              <Text size={"sm"} weight="extraBold">
                توضیحات سفارش:
              </Text>
              <Text style={{ lineHeight: mq(22) }}>
                {data?.data?.description}
              </Text>
            </View>
          )}

          {data?.data?.items?.map((item: FactorItemsDataT, key: number) => {
            return (
              <View
                style={{
                  marginTop: mq(25),
                  borderBottomWidth: 1,
                  borderColor: colors.border.lightest,
                  paddingVertical: 10,
                }}
                key={String(key)}
              >
                <View style={{ ...css.rRowCenterAlign }}>
                  <View
                    style={{
                      top: mq(2),
                      ...css.circle(10),
                      backgroundColor: colors.theme,
                    }}
                  />
                  <Text weight="extraBold" size={"sm"} color={colors.text.dark}>
                    {" "}
                    {item.product_name}
                  </Text>

                  <View
                    style={{
                      flexDirection: "row-reverse",
                      marginHorizontal: 6,
                    }}
                  >
                    {item?.new_attributes?.map((attr: string, key: number) => {
                      return (
                        <Text key={String(key)}>
                          {key !== 0 &&
                            item.new_attributes?.length > 1 &&
                            " - "}
                          {attr}
                        </Text>
                      );
                    })}
                  </View>
                </View>
                <View style={{ paddingRight: mq(12), marginTop: mq(5) }}>
                  {item?.description && (
                    <View
                      style={{
                        ...css.selfEnd,
                        marginHorizontal: mq(10),
                        marginBottom: mq(10),
                        backgroundColor: colors.border.lightest + "99",
                        paddingHorizontal: mq(5),
                      }}
                    >
                      <Text
                        weight="bold"
                        style={{ lineHeight: mq(22), bottom: mq(1) }}
                      >
                        {item.description}
                      </Text>
                    </View>
                  )}

                  <View style={{ ...css.rRowCenterAlign }}>
                    <View
                      style={{ ...css.rRowCenterAlign, borderRadius: mq(10) }}
                    >
                      <View
                        style={{
                          height: mq(20),
                          borderRadius: mq(12),
                          paddingHorizontal: mq(4),
                          backgroundColor: colors.bg.light,
                        }}
                      >
                        <Text
                          size={"lg"}
                          color={colors.theme}
                          weight="extraBold"
                          style={Platform.select({
                            native: { bottom: 3 },
                            web: { top: 2 },
                          })}
                        >
                          {" "}
                          {item.count}{" "}
                        </Text>
                      </View>
                      <Text
                        size={"xs"}
                        weight="extraBold"
                        color={colors.text.gray}
                      >
                        {" "}
                        عدد{" "}
                      </Text>
                    </View>
                    {item?.description ? (
                      <></>
                    ) : (
                      <>
                        <Text> x </Text>
                        <Text weight="bold">{priceFormatter(item.price)}</Text>
                      </>
                    )}

                    <View style={css.container} />

                    {item?.description ? (
                      <></>
                    ) : (
                      <>
                        <Text color={colors.theme} weight="extraBold">
                          {priceFormatter(item.total_price)}
                        </Text>
                        <Text
                          size={"xxs"}
                          color={colors.text.gray}
                          weight="extraBold"
                        >
                          {" "}
                          {strings.currency}
                        </Text>
                      </>
                    )}
                  </View>
                </View>
              </View>
            );
          })}
          <View style={{ height: 120 }} />
        </ListContainer>

        <ExportPDF
          extraData={data?.data}
          template={makeFactorPdfTemplate(data?.data)}
        />
      </>
    );
  };

  return (
    <>
      <Header title={`فاکتور شماره ${params.id}`} />
      <View style={{ ...css.container }}>{_renderContent()}</View>
    </>
  );
}
